import * as yup from "yup";
import { t } from "i18next";

export const getCreatePinSchema = () =>
  yup.object().shape({
    pin: yup
      .string()
      .required(t("validation.required"))
      .matches(/^\d{4}$/, t("validation.invalidPin")),
    confirmPin: yup
      .string()
      .required(t("validation.required"))
      .oneOf([yup.ref("pin")], t("validation.pinMustMatch")),
  });
